import { yupResolver } from '@hookform/resolvers/yup';
import React, { useMemo, useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
// utils
// routes
import { useRouter } from 'src/routes/hook';
// types
import { IUserItem } from 'src/types/user';
// assets
// components
import FormProvider, {
  RHFCheckbox, RHFSelect,
  RHFTextField
} from 'src/components/hook-form';
import { useSnackbar } from 'src/components/snackbar';
import { useMockedUser } from 'src/hooks/use-mocked-user';
import { paths } from 'src/routes/paths';
import axios, { endpoints } from 'src/utils/axios';
import Typography from "@mui/material/Typography";
import { useBoolean } from 'src/hooks/use-boolean';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import {Button, MenuItem} from "@mui/material";
import { NutritionValues } from 'src/sections/user/NutritionHelper';
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {useTheme} from "@mui/material/styles";
import {IIngredient} from "../../types/code";

interface NutritionField {
  key: string;
  value: string;
}
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
type FormData = {
  name: string;
  name_en: string | undefined;
  calories: string;
  protein: string;
  carbonhydrates: string;
  fiber: string;
  fat: string;
  category: string;
  unit: string; // Add this
};

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
      <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
      >
        {value === index && (
            <Box sx={{ p: 0 }}>
              <Typography>{children}</Typography>
            </Box>
        )}
      </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
// ----------------------------------------------------------------------

export default function IngredientNewEditForm({ defaultValues,recipepage=false,setOpenDialog }: { defaultValues: IIngredient | null ,recipepage?:boolean, setOpenDialog ?: (open: boolean) => void}) {
  const { t, currentLang } = useLocales();
  const router = useRouter();
  const { user } = useMockedUser();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();

  const [value, setValue] = React.useState(currentLang.value === 'de' ? 0 : 1);
  console.log(defaultValues===null);
  console.log(defaultValues);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };


  const NewCodeSchema = Yup.object().shape({
    name: Yup.string().required(t('NAME_REQ')),
    name_en: Yup.string().optional(),
    calories: Yup.string().required(t('CALORIES_REQ')),
    protein: Yup.string().required(t('PROTEIN_REQ')),
    carbonhydrates: Yup.string().required(t('CARBONHYDRATES_REQ')),
    fiber: Yup.string().required(t('FIBER_REQ')),
    fat: Yup.string().required(t('FAT_REQ')),
    category: Yup.string().required(t('CATEGORY_REQ')),
    unit: Yup.string().required(t('UNIT_REQ')), // Add this line
  });

  const defaultValuesProp = useMemo(
      () => ({
        name: defaultValues?.name,
        name_en: defaultValues?.name_en || '',
        calories: defaultValues?.calories?.toString(),
        protein: defaultValues?.protein?.toString(),
        carbonhydrates: defaultValues?.carbonhydrates?.toString(),
        fiber: defaultValues?.fiber?.toString(),
        fat: defaultValues?.fat?.toString(),
        category: defaultValues?.category?.toString(),
        unit: defaultValues?.ingredientUnit?.toString(), // Add this line
      }), [defaultValues]
  );

  const initialNutritionFields = useMemo(() => {
    console.log(defaultValuesProp);
    if (!defaultValues) return [];
    const nutritionData = Object.entries(defaultValues).filter(([key, value]) =>
        !['name', 'name_en', 'calories', 'protein', 'carbonhydrates', 'fiber', 'fat', 'category', 'ingredientUnit','created_at','updated_at','baseQty','added_by','brand_name','img_category','id'].includes(key) && value !== 0
    );
    return nutritionData.map(([key, value]) => ({
      key,
      value: value?.toString() || ''
    }));
  }, [defaultValues]);



  const methods = useForm<FormData>({
    resolver: yupResolver(NewCodeSchema),
    defaultValues:defaultValuesProp
  });

  const {
    reset,
    watch,
    handleSubmit,
  } = methods;

  const onSubmit = handleSubmit(async (data) => {
    // console.log("user",user);
    // console.log("userID",user?.id);
    //
    // return


    try {
      const nutritionData = nutritionFields.reduce((acc, field) => {
        if (field.key) {
          acc[field.key] = field.value ? parseFloat(field.value.replace(',', '.')) : 0;
        }
        return acc;
      }, {} as Record<string, number>);

      const dataToSend = {
        ingid: defaultValues===null?0:defaultValues.id,
        added_by: user?.tenant_id,
        name: data.name,
        name_en: data.name_en,
        calories: parseFloat(data.calories.replace(',', '.')),
        protein: parseFloat(data.protein.replace(',', '.')),
        carbonhydrates: parseFloat(data.carbonhydrates.replace(',', '.')),
        fiber: parseFloat(data.fiber.replace(',', '.')),
        fat: parseFloat(data.fat.replace(',', '.')),
        ingredientUnit: Number(data.unit),
        selectedunit: Number(data.unit),
        category: data.category,
        ...nutritionData
      };
      setIsLoading(true);
      const response = await axios.post(endpoints.recipe.addNewIngredient, dataToSend);
      setIsLoading(false);
      if (response.status === 200) {
        if(defaultValues===null || recipepage===true){
            enqueueSnackbar(t("ALERT_INGREDIENT_ADDED"));
        }else {
            enqueueSnackbar(t("ING_UPDATED_SUCCESSFULLY"));
        }

        if(recipepage===false){
          router.push(paths.dashboard.ingredient.root);
        }else if(typeof setOpenDialog !== 'undefined') {
            setOpenDialog(false)
          }


        reset();
        // setOpenDialog(false);
        // router.push(paths.dashboard.recipe.root);
      } else {
        enqueueSnackbar('Something went wrong!!', { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Something went wrong!!', { variant: 'error' });
      console.error(error);
    }
  });



  // const [selectedunit, setUnit] = useState(defaultValues===null?0:Number(defaultValues.ingredientUnit)); // Initialize with a default value
  const selectedunit = Number(watch('unit') || 0); // Default to 0 if 'unit' is undefined
  
  const [nutritionFields, setNutritionFields] = useState<NutritionField[]>(initialNutritionFields);
  const [loading, setIsLoading] = React.useState<boolean>(false);

  // const handleUnitChange = (event: React.ChangeEvent<{ value: unknown }>) => {
  //   setUnit(event.target.value as number);
  // };

  const handleAddNutritionField = () => {
    setNutritionFields([...nutritionFields, { key: '', value: '' }]);
  };

  useEffect(() => {
    handleAddNutritionField();
  }, []);


  const handleNutritionChange = (index: number, field: keyof NutritionField, value: string) => {
    const newFields = [...nutritionFields];
    newFields[index] = {
      ...newFields[index],
      [field]: value
    };
    setNutritionFields(newFields);
  };

  const UnitOptions = [
    {
      label: t("LABEL_ML"),
      value: 0,
    },
    {
      label: t("LABEL_GR"),
      value: 1,
    },
    {
      label: t("LABEL_UNIT"),
      value: 2,
    },
    {
      label: t("LABEL_SLICE"),
      value: 3,
    },
    {
      label: t("LABEL_EL"),
      value: 4,
    },
    {
      label: t("LABEL_TL"),
      value: 5,
    },
    {
      label: t("LABEL_CUP"),
      value: 6,
    },
    {
      label: t("LABEL_PINCH"),
      value: 7,
    },
    {
      label: t("LABEL_CLOVE"),
      value: 8,
    },
    {
      label: t("LABEL_PK"),
      value: 9,
    },
    {
      label: t("LABEL_TUB"),
      value: 10,
    },
    {
      label: t("LABEL_ROLL"),
      value: 11,
    },
    {
      label: t("LABEL_LEAVES"),
      value: 12,
    },
    {
      label: t("LABEL_BUNCH"),
      value: 13,
    },
    {
      label: t("LABEL_HEAD"),
      value: 14,
    },
    {
      label: t("LABEL_PORTION_UNIT"),
      value: 15
    }
  ];

  const category = [
    {
      label:t("LABEL_STEP_MEAT"),
      value:0
    },
    {
      label:t("LABEL_STEP_FRUVEG"),
      value:1
    },
    {
      label:t("LABEL_STEP_CEREALS"),
      value:2
    },
    {
      label:t("LABEL_STEP_MILK"),
      value:3
    },
    {
      label:t("LABEL_STEP_OTHERS"),
      value:4
    },
    {
      label:t("LABEL_HERBS"),
      value:5
    },
    {
      label:t('LABEL_STEP_FISH'),
      value:6
    },
    {
      label:t("OWN_FOODS_CAT"),
      value:8
    }
  ];


  return (
      <FormProvider methods={methods} onSubmit={onSubmit}>

        <Grid container spacing={3}>
          <Grid xs={12} md={defaultValues===null && recipepage===false?8:12}>
            <Card sx={{ p: 3 }}>

                <Box
                  rowGap={3}
                  columnGap={2}
                  display="grid"
                  gridTemplateColumns="repeat(1, 1fr)"

              >

                  <Grid container spacing={3}>
                    <Grid xs={12} md={12}>

                      <Box
                          rowGap={3}
                          columnGap={2}
                          display="grid"
                          gridTemplateColumns={{
                            xs: 'repeat(2, 1fr)',
                            sm: 'repeat(2, 1fr)',
                          }}
                      >
                        <Box sx={{ width: '100%' }} style={{ gridColumn: 'span 2' }}>
                          <Box style={{ height: '35px' }}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                style={{ height: '35px' }}
                                sx={{
                                  borderBottom: 'none',
                                  '& .MuiTabs-indicator': {
                                    display: 'none' // This hides the indicator line
                                  }
                                }}
                            >
                              <Tab
                                  style={{ fontSize: '10px', padding: 0, margin: 0 }}
                                  label={t("GERMAN")}
                                  {...a11yProps(0)}
                                  sx={{ borderBottom: 'none' }}
                              />
                              <Tab
                                  style={{ fontSize: '10px', padding: 0, margin: 0 }}
                                  label={t("ENGLISH")}
                                  {...a11yProps(1)}
                                  sx={{ borderBottom: 'none' }}
                              />
                            </Tabs>
                          </Box>
                          <CustomTabPanel value={value} index={0}>
                            <RHFTextField name="name" label={t("INPUT_FIELD_INGREDIENT_NAME")}     sx={{ gridColumn: 'span 2' }} />
                          </CustomTabPanel>

                          <CustomTabPanel value={value} index={1}>
                            <RHFTextField name="name_en" label={t("INPUT_FIELD_INGREDIENT_NAME_EN")}     sx={{ gridColumn: 'span 2' }}/>
                          </CustomTabPanel>

                        </Box>

                        <RHFSelect
                            name="unit"
                            label={t("INGREDIENT_UNIT")}
                            InputLabelProps={{ shrink: true }}
                        >
                          {UnitOptions.map(unit => (
                              <MenuItem key={unit.value} value={unit.value.toString()}>
                                {unit.label}
                              </MenuItem>
                          ))}
                        </RHFSelect>

                        <RHFSelect
                            name="category"
                            label={t("CATEGORY")}
                            InputLabelProps={{ shrink: true }}
                        >
                          {category.map(cat => (
                              <MenuItem key={cat.value} value={cat.value.toString()}>
                                {cat.label}
                              </MenuItem>
                          ))}
                        </RHFSelect>

                        <h3 style={{ gridColumn: 'span 2', marginBottom:'0'}}>{t("NUTRITION_VALUES")}</h3>
                        <Box
                            rowGap={3}
                            columnGap={2}
                            display="grid"
                            gridTemplateColumns="repeat(2, 1fr)"
                            sx={{gridColumn: 'span 2'}}
                        >

                        <RHFTextField name="calories"
                                      label={
                                        selectedunit === 0 || selectedunit === 1
                                            ? `${t("LABEL_KALORIEN")} ${t("PER")} 100 ${t(UnitOptions[selectedunit]?.label || "")}`
                                            : `${t("LABEL_KALORIEN")} ${t("PER")} ${t(UnitOptions[selectedunit]?.label || "")}`
                                      }
                        />
                        <RHFTextField name="protein"
                                      label={
                                        selectedunit === 0 || selectedunit === 1
                                            ? `${t("LABEL_PROTEIN")} ${t("PER")} 100 ${t(UnitOptions[selectedunit]?.label || "")}`
                                            : `${t("LABEL_PROTEIN")} ${t("PER")} ${t(UnitOptions[selectedunit]?.label || "")}`
                                      }
                        />
                        <RHFTextField name="carbonhydrates"
                                      label={
                                        selectedunit === 0 || selectedunit === 1
                                            ? `${t("LABEL_CARBS")} ${t("PER")} 100 ${t(UnitOptions[selectedunit]?.label || "")}`
                                            : `${t("LABEL_CARBS")} ${t("PER")} ${t(UnitOptions[selectedunit]?.label || "")}`
                                      }
                        />
                        <RHFTextField name="fat"
                                      label={
                                        selectedunit === 0 || selectedunit === 1
                                            ? `${t("LABEL_FAT")} ${t("PER")} 100 ${t(UnitOptions[selectedunit]?.label || "")}`
                                            : `${t("LABEL_FAT")} ${t("PER")} ${t(UnitOptions[selectedunit]?.label || "")}`
                                      }
                        />
                        <RHFTextField name="fiber"
                                      label={
                                        selectedunit === 0 || selectedunit === 1
                                            ? `${t("LABEL_FIBER")} ${t("PER")} 100 ${t(UnitOptions[selectedunit]?.label || "")}`
                                            : `${t("LABEL_FIBER")} ${t("PER")} ${t(UnitOptions[selectedunit]?.label || "")}`
                                      }
                        />
                        </Box>

                        <h3 style={{ gridColumn: 'span 2',marginBottom:'0' }}>{t("ADD_FURTHER_NUTRIENT_VALUES")}</h3>
                        <Box
                            rowGap={3}
                            columnGap={2}
                            display="grid"
                            gridTemplateColumns="repeat(1, 1fr)"
                            sx={{gridColumn: 'span 2'}}
                        >
                        {nutritionFields.map((field, index) => (
                            <Box key={index} display="flex" alignItems="center" sx={ {columnGap: 2} }>
                              <RHFSelect
                                  name={`nutrition_${index}_key`}
                                  label={t("NUTRIENT")}
                                  value={field.key}
                                  onChange={(e) => handleNutritionChange(index, 'key', e.target.value)}
                                  selectSx={{ textTransform: 'none' }}
                              >
                                {NutritionValues.map((option) => (
                                    <MenuItem key={option.key} value={option.key}>
                                      {`${t(option.name)} (${option.unit})`}
                                    </MenuItem>
                                ))}
                              </RHFSelect>
                              <RHFTextField
                                  name={`nutrition_${index}_value`}
                                  label={
                                    selectedunit === 0 || selectedunit === 1
                                        ? `${t(`LABEL_${field.key===""?"NUTRIENT":field.key.toUpperCase()}`)} ${t("PER")} 100 ${UnitOptions[selectedunit].label}`
                                        : `${t(`LABEL_${field.key.toUpperCase()}`)} ${t("PER")} ${UnitOptions[selectedunit].label}`
                                  }
                                  value={field.value}
                                  onChange={(e) => handleNutritionChange(index, 'value', e.target.value)}
                              />
                            </Box>
                        ))}
                        </Box>
                        <LoadingButton sx={{
                          backgroundColor: 'primary.main', // Replace 'your_color_here' with your desired color
                          color: 'white',
                          '&:hover': {
                            backgroundColor: 'primary.main', // 20% transparency
                          },
                        }} onClick={handleAddNutritionField}>{t("ADD_ANOTHER_MACRO")}</LoadingButton>
                      </Box>
                    </Grid>
                  </Grid>

              </Box>
              <Stack alignItems="flex-end" sx={{ mt: 3 }}>
                <LoadingButton loading={loading} type="submit" variant='contained' >
                  {defaultValues===null?t("BUTTON_CREATE_NEW_ENTRY"):t("UPDATE_ING_BUTTON")}
                </LoadingButton>
              </Stack>
            </Card>
          </Grid>
        </Grid>

      </FormProvider>
  );
}